import React from 'react';
import './bootstrap/dist/css/bootstrap.min.css';
import Main from './components/Main/Main';
import Navbar from './components/navbar/Navbar';
import Footer from './components/footer/Footer';
import { MobileNavProvider } from './contexts/MobileNavContext';

const App = () => {
	return (
		<MobileNavProvider>
			<Navbar />
			<Main />
			{/* <Footer /> */}
		</MobileNavProvider>
	)
	//footer after main
}

export default App;